import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { formatMessage } from "devextreme/localization";
import { UserService } from "../../../../../services/user.service";
import { User } from "../../../../../model/user/user";
import { compareStringsAlphabeticallyIgnoreCase } from "../../../../../utils/stringUtils";
import { OrganizationService } from "../../../../../services/organization.service";
import { Publisher } from "../../../../../model/organization/organization";
import { DxFormComponent } from "devextreme-angular";
import { GeneralInformation } from "../../../../../model/calculator-us-remastered/generalInformation";

@Component({
  selector: "app-calculator-general-information",
  templateUrl: "./calculator-general-information.component.html",
  styleUrls: ["./calculator-general-information.component.scss"],
})
export class CalculatorGeneralInformationComponent
  implements OnInit, OnChanges
{
  @ViewChild(DxFormComponent) form: DxFormComponent;

  private _generalInformation: GeneralInformation;
  @Input()
  set generalInformation(val: GeneralInformation) {
    this._generalInformation = val;
  }
  get generalInformation(): GeneralInformation {
    return this._generalInformation;
  }

  @Output() onValueChanged = new EventEmitter<[GeneralInformation, boolean]>();

  formatMessage = formatMessage;

  collapsed: any = true;

  publishers: Publisher[];

  get selectedPublisher() {
    return this.generalInformation.publisher;
  }
  set selectedPublisher(val: Publisher | undefined) {
    if (this._generalInformation.publisher === val) return;
    this._generalInformation.publisher = val;
    this.onValueChanged.emit([this.generalInformation, true]);
  }

  customerContacts: string[];
  get selectedCustomerContact() {
    return this.generalInformation.customerContact;
  }
  set selectedCustomerContact(val: string) {
    this._generalInformation.customerContact = val || "";
    this.onValueChanged.emit([this.generalInformation, false]);
  }

  bpgContacts: string[];

  get selectedBpgContact() {
    return this.generalInformation.bpgContact;
  }
  set selectedBpgContact(val: string) {
    this._generalInformation.bpgContact = val || "";
    this.onValueChanged.emit([this.generalInformation, false]);
  }

  get date() {
    return this._generalInformation.date;
  }
  set date(val: string) {
    this._generalInformation.date = val;
    this.onValueChanged.emit([this.generalInformation, false]);
  }

  constructor(
    private organizationService: OrganizationService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.userService.findOwnUser().subscribe((user) => {
      if (user && user.identity) {
        this.loadPublishers(user);

        if (user.identity.isInternal) {
          // remove customerContact after implementation of contact administration
          this.selectedBpgContact = user.identity.email;
          this.selectedCustomerContact = "";
        } else {
          this.selectedBpgContact = "Estimating@bpg-usa.com";
          this.selectedCustomerContact = user.identity.email;
        }
      }
    });

    this.loadFieldItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedPublisherId) {
      this.loadFieldItems();
    }
  }

  private loadPublishers(user: User) {
    if (
      user.role == "ADMIN" ||
      user.role == "ADMIN_US" ||
      user.role == "KEY_USER"
    ) {
      this.organizationService.findAllPublisher().subscribe((org) => {
        if (org) {
          org.sort((a, b) =>
            compareStringsAlphabeticallyIgnoreCase(a.displayName, b.displayName)
          );
          if (org.length == 1) this.selectedPublisher = org[0];
          this.publishers = org;
        }
      });
    } else {
      let publishers = new Array();
      if (user.worksFor) {
        // get publisher from organizations
        for (let i = 0; i < user.worksFor.length; i++) {
          if (user.worksFor[i].id) {
            this.organizationService
              .findPublisherByOrganizationId(user.worksFor[i].id)
              .subscribe(
                (value) => {
                  if (value) {
                    publishers.push(value);
                    this.publishers = publishers;
                  }
                  if (user.worksFor.length == 1 && publishers.length == 1) {
                    this.selectedPublisher = this.publishers[0];
                  }
                },
                (e) => {
                  console.error(e);
                }
              );
          }
        }
      }
    }
  }

  private loadFieldItems(): void {
    if (!this.selectedPublisher?.id) {
      return;
    }
  }

  onAccordionClick(e) {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    this.collapsed = e.component.option("selectedIndex") == -1;

    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 100);
  }
}
